<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<div class="form-head">
					<ul class="uk-breadcrumb">
						<li><a href="/">
							{{ $t('home') }}
						</a></li>
					</ul>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="form">
					<div class="row">
						<div class="col-sm-12">
							<div class="form-body">
								<div id="draft-items" class="wrapped-box">
									<p>
										{{ $t('incompleted.items')}}:
										<div v-for="(draft, key) in draftCountArray" :key="key">{{draft.status}}: <b>{{draft.count}}</b><span class="drafts-link"><a
										:href="'/item-table?filter=' + draft.filter">{{$t('go.to.incompleted.items')}}<span
										class="fa fa-arrow-right"></span></a></span></div>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { DASHBOARD_DRAFT_COUNT } from 'actions/dashboard'

export default {
	name: 'Dashboard',
	metaInfo () {
		return  {
			title: this.$t('dashboard')
		}
	},
	components: {},
	data () {
		return {
			loading: false,
			draftCountArray: null,
			error: null
		}
	},
	mounted () {
		if (this.$store.getters.isAuthenticated)
			this.fetchData()
	},
	methods: {
		fetchData () {
			this.$store.dispatch(DASHBOARD_DRAFT_COUNT).then(res => {
				this.draftCountArray = res
				this.loading = true
			}).catch(err => {
				this.error = err.data
				this.rollbar.error('DASHBOARD_DRAFT_COUNT', err)
			})
		}
	}
}
</script>
